import { t } from 'i18next'

export const GENERIC_ERROR = t('genericErrorBody')

export const SUPPORT_EMAIL = 'support@groupcal.app'
export const SUPPORT_EMAIL_TFM = 'support@twentyfour.me'

export function capitalizeFirstChar(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function rtlString(str: string) {
  return `‎${str}`
}

export function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}
